import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaSlidersH } from 'react-icons/fa';

import { AddButton, Box, Button, TextInput } from '@qwealth/qcore';
import { selectPartners } from '@qwealth/qdata';

import { useDebounce } from 'hooks/useDebounce';
import { getKyps, queryKyp } from 'data/actions/KYP';
import { initialKypFilters } from 'data/refData/kyp';
import KypModal from '../KypModal/KypModal';
import KypFilterSection from './KypFilters';

interface KypActionbarProps {
  isSmallScreen: boolean;
}

const KypSearchAndActionBar: FC<KypActionbarProps> = ({ isSmallScreen }): JSX.Element => {
  const partners = useSelector(selectPartners);
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState<string | undefined>();
  const debouncedQuery = useDebounce(searchQuery ? searchQuery.toLowerCase() : '', 1000); //Wait for user to stop typing before querying

  const [showCreateProductModal, setShowCreateProductModal] = useState<boolean>(false);
  const [showFilterModal, setShowFilterModal] = useState<boolean>(false);

  useEffect(() => {
    if (searchQuery !== undefined) {
      dispatch(queryKyp(debouncedQuery));
    }
  }, [debouncedQuery]);

  useEffect(() => {
    dispatch(getKyps(initialKypFilters));
  }, []);

  const closeModal = () => {
    setShowCreateProductModal(false);
    setShowFilterModal(false);
  };

  return (
    <Box width="100%" marginBottom="default">
      <Box display="flex" flexDirection="row" width="100%" marginBottom="large">
        <TextInput
          width="100%"
          placeholder="Search Products"
          onChange={e => {
            setSearchQuery(e.target.value);
          }}
          value={searchQuery}
        />
        {isSmallScreen && (
          <Button
            size="small"
            variant="outline"
            data-testid="filter-toggle-btn"
            minWidth="15vh"
            onClick={() => {
              setShowFilterModal(true);
            }}
            gap="default"
            marginLeft="large"
          >
            <Box paddingLeft="large" paddingRight="large" display="flex" flexDirection="row" alignItems="center" gap="default" height="25px">
              <FaSlidersH size="18px" />
              <Box fontWeight="bolder">Filter</Box>
            </Box>
          </Button>
        )}

        <AddButton
          size="small"
          color="primary"
          minWidth="15vh"
          marginLeft="large"
          onClick={() => {
            setShowCreateProductModal(true);
          }}
        >
          Product
        </AddButton>
      </Box>

      {!isSmallScreen && <KypFilterSection />}

      <KypModal
        onClose={closeModal}
        show={showCreateProductModal || showFilterModal}
        partners={partners}
        type={showFilterModal ? 'filter' : 'create'}
      />
    </Box>
  );
};

export default KypSearchAndActionBar;
